var React = require('react');

function Varuhiss (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"153","y":"32","width":"127","height":"115","rx":"2","transform":"rotate(90 153 32)","stroke":"#000","strokeWidth":"4","key":0}),React.createElement("rect",{"x":"139","y":"60","width":"99","height":"88","rx":"2","transform":"rotate(90 139 60)","stroke":"#000","strokeWidth":"4","key":1}),React.createElement("path",{"d":"m77 50-5-6-5 6","stroke":"#000","strokeWidth":"4","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"m112 44 5 6 5-6","stroke":"#000","strokeWidth":"4","strokeLinecap":"round","strokeLinejoin":"round","key":3}),React.createElement("path",{"d":"M96 61v96","stroke":"#000","strokeWidth":"5","strokeLinecap":"round","strokeLinejoin":"round","key":4})]);
}

Varuhiss.defaultProps = {"viewBox":"0 0 191 191","width":"191","height":"191","fill":"none"};

module.exports = Varuhiss;

Varuhiss.default = Varuhiss;
